import { createFileRoute } from '@tanstack/react-router';

import { TailoredSupplyEditorPage } from '../features/campaigns/supply/components/TailoredSupplyEditorPage';

export const Route = createFileRoute('/campaigns/supply/tailored-supply/edit/$tailoredSupplyId')({
  component: EditTailoredSupplyRoute,
});

function EditTailoredSupplyRoute() {
  const { tailoredSupplyId } = Route.useParams();
  return <TailoredSupplyEditorPage tailoredSupplyId={tailoredSupplyId} />;
}
